export default __webpack_public_path__ + "static/media/prev-C1A-2.32707d94.png";